import { graphql } from "@apollo/client/react/hoc"
import produce from "immer"
import compose from "lodash/flowRight"
import { CreatePathItemDocument, PathDocument } from "../../api/generated"
import { getPathItems } from "../graphql/withPathItems"
import withReorderPathItems from "../graphql/withReorderPathItems"
import withPathQueryVariables from "./withPathQueryVariables"

export default compose(
  withPathQueryVariables,
  withReorderPathItems,
  graphql(CreatePathItemDocument, {
    props: ({ mutate, ownProps }) => ({
      createPathItem: async (args) =>
        mutate({
          variables: {
            name: args.name,
            type: args.type,
            order: args.order,
            assignment_type: args.assignment_type,
            parent: args.parent,
            path_id: args.pathId,
            description: args.description,
            content_type: args.content_type,
            content_group: args.content_group,
            content_resource: args.content_resource
          },
          update: (cache, result) => {
            const query = PathDocument
            const variables = ownProps.pathQueryVariables
            let data = cache.readQuery({ query, variables })

            // add created item into path items
            const nextData = produce(data, (draft) => {
              const createdItem = result.data.createPathItem
              const newEdge = {
                node: createdItem,
                __typename: "PathItemEdge"
              }
              draft.path.items.edges.splice(0, 0, newEdge)
            })

            // add item to path
            cache.writeQuery({ query, variables, data: nextData })

            // trigger reorder
            data = cache.readQuery({ query, variables })
            // reorders items in cache after reorder mutation runs
            ownProps.reorderPathItems(getPathItems(data))
          }
        })
    })
  })
)
